import { Tile } from '../atom.tile/_tile-input.js';
import { jsx } from 'react/jsx-runtime';

function MatchTile(props) {
  return /*#__PURE__*/jsx(Tile, {
    tile: props.tile,
    state: props.tile.fixed ? "fixed" : props.state,
    isDraggable: !!props.isDraggable,
    isDragOverlay: !!props.isDragOverlay
  });
}

export { MatchTile };
//# sourceMappingURL=atom.tile.js.map
